const brMapDrawing = {
  mapDrawing: {
    appointments: 'Agendamentos',
    groups: 'Grupos',
    status: 'Status',
    startDate: 'Data de Início',
    endDate: 'Data de Final',
    time: 'Período',
    showGroupedAppointments: 'Mostrar agendamentos agrupados',
    appointmentCode: 'Código do Agendamento',
    close: 'Fechar',
    cancel: 'Cancelar',
    cancelOrRemoveFromGroup: 'Cancelar / Remover do grupo',
    reschedule: 'Reagendar',
    sendConfirmationEmail: 'Enviar e-mail de confirmação',
    sendRejectedEmail: 'Enviar e-mail de aviso de rejeição',
    changeAppointmentStatus: 'Alterar status',
    bulkActions: 'Ações em massa',
    removeGroup: 'Remover grupo',
    removeGroupMessage: 'Primeiro remova o host, para então remover o grupo',
    addToGroup: 'Adicionar ao grupo',
    groupInfo: 'Informações do grupo',
    changeHost: 'Alterar host',
    removeHost: 'Remover host',
    addHost: 'Adicionar host',
    code: 'Código',
    scheduledBy: 'Agendado por',
    host: 'Host',
    hostValue: 'Valor do Host',
    date: 'Data',
    totalValue: 'Valor total',
    search: 'Buscar',
    confirmed: 'Confirmado',
    customers: 'Clientes',
    branches: 'Filiais',
    hosts: 'Hosts',
    services: 'Serviços',
    confirmationSent: 'Confirmação enviada',
    tooltipCloseToShowGroupedServices: 'Clique em fechar para listar os agendamentos agrupados',
    timeInMinutes: 'Tempo (minutos)',
    pauseAppointmentOffer: 'Pausar oferta de agendamentos',
    other: 'Outro',
    pause: 'Pausar',
    cancel: 'Cancelar',
    unpause: 'Despausar',
    unpauseWarning: 'Você tem certeza que deseja despausar as ofertas de agendamento?',
    removeGroupModal: {
      title: 'Remover grupo',
      message: 'Tem certeza que deseja remover o grupo?',
      cancel: 'Cancelar',
      remove: 'Remover',
    },
    removeAppointmentFromGroupModal: {
      title: 'Remover agendamento do grupo',
      type: 'Tipo',
      status: 'Status',
      code: 'Código',
      realEstate: 'Imobiliária',
      cancel: 'Cancelar',
      remove: 'Remover',
    },
    drawPolygon: 'Desenhar polígono',
    drawingHint: 'Clique no ponto inicial para fechar · Esc para cancelar',
    clearHint: 'Esc para limpar a seleção',
    messages: {
      appointmentNotFound: 'Agendamento não encontrado',
    },
  }
}

export default brMapDrawing
